import React from "react";
import { CheckCircle2Icon } from "lucide-react";
type Props = {
  items: string[];
  tone?: "dark" | "light";
};
export function TrustRow({
  items,
  tone = "light"
}: Props) {
  return <ul className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2 sm:flex sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-329" data-mp="2ho7sk3gehxbh">
      {items.map(item => <li key={item} className={`flex items-center gap-1.5 text-[13px] font-semibold ${tone === "dark" ? "text-white/90" : "text-ink"}`} data-id="element-330" data-mp="2cqpdrwfpcnvk">
          <CheckCircle2Icon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-331" data-mp="1p1myuwcgd94r" />
          {item}
        </li>)}
    </ul>;
}